import * as React from "react";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import UserSearchFilterForm from "search-filter/components/filter-management-pages/UserSearchFilterForm";
import { Col, Row, Alert } from "components/bootstrap";
import { Headline } from "components/common/Section/SectionComponent";
import useUserSearchFilterQuery from "search-filter/hooks/useUserSearchFilterQuery";
import useUserSearchFilterMutation from "search-filter/hooks/useUserSearchFilterMutation";
import { NoSearchResult, Spinner, Link } from "components/common";
import useSearchFilterUsagesSummaryQuery from "search-filter/hooks/useSearchFilterUsagesSummaryQuery";
import readableFilterUsagesSummary from "search-filter/readableFilterUsagesSummary";
import StringUtils from "util/StringUtils";
import confirmActionUsagesAlert from "search-filter/confirmActionUsagesAlert";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import SearchFiltersRoutes from "search-filter/Routes";
const UserSearchFilterEdit = () => {
  const { filterId } = useParams();
  const { put } = useUserSearchFilterMutation();
  const { data: searchFilter, isFetching } = useUserSearchFilterQuery(filterId);
  const {
    data: { summary: usagesSummary },
    isFetching: isFetchingUsagesSummary
  } = useSearchFilterUsagesSummaryQuery(filterId);
  const history = useHistory();
  const sendTelemetry = useSendTelemetry();
  const onSave = useCallback(
    (updatedSearchFilter) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_FILTER_UPDATED, {
        app_pathname: "my-filters",
        app_section: "search-filter"
      });
      const queryHasChanged = (searchFilter == null ? void 0 : searchFilter.queryString) !== updatedSearchFilter.queryString;
      if ((usagesSummary == null ? void 0 : usagesSummary.length) && queryHasChanged && !confirmActionUsagesAlert({ action: "Changing", usagesSummary })) {
        return Promise.resolve();
      }
      return put({ id: filterId, data: updatedSearchFilter }).then(() => {
        history.push(SearchFiltersRoutes.LIST);
      });
    },
    [filterId, history, put, searchFilter == null ? void 0 : searchFilter.queryString, usagesSummary, sendTelemetry]
  );
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { lg: 8 }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(Headline, null, "Edit Filter"))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(
    UserSearchFilterForm,
    {
      onSubmit: onSave,
      action: "edit",
      disableSubmitButton: isFetchingUsagesSummary,
      submitButtonText: "Update filter",
      submitLoadingText: "Updating filter...",
      initialValues: {
        queryString: searchFilter == null ? void 0 : searchFilter.queryString,
        title: searchFilter == null ? void 0 : searchFilter.title,
        description: searchFilter == null ? void 0 : searchFilter.description
      }
    },
    /* @__PURE__ */ React.createElement(Row, { className: "has-bm" }, /* @__PURE__ */ React.createElement(Col, { md: 9, mdOffset: 3 }, isFetchingUsagesSummary && /* @__PURE__ */ React.createElement(Spinner, { text: "Loading usages summary..." }), !isFetchingUsagesSummary && !(usagesSummary == null ? void 0 : usagesSummary.length) && /* @__PURE__ */ React.createElement(NoSearchResult, null, "Editing this search filter will not affect any saved search or dashboard, since the filter is currently not being referenced."), !isFetchingUsagesSummary && !!(usagesSummary == null ? void 0 : usagesSummary.length) && /* @__PURE__ */ React.createElement(Alert, { className: "no-bm", bsStyle: "danger", title: "Attention!" }, "This search filter is being referenced by", " ", /* @__PURE__ */ React.createElement(Link, { to: SearchFiltersRoutes.SHOW(filterId), target: "_blank" }, readableFilterUsagesSummary(usagesSummary)), ". Changing the search filter query will affect", " ", StringUtils.pluralize(usagesSummary.length, "its", "their"), " search result.")))
  )))));
};
export default UserSearchFilterEdit;
